/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const explain_share_body = () => `Wil je een ticket delen met een vriend(in)? Dat kan in een paar klikken. Je kunt het ticket direct overdragen, of de ander eerst laten betalen — dat bedrag wordt dan automatisch aan jou teruggestort. Geen Tikkie meer nodig.`
